import { useSelector } from "react-redux";
import { pbxIdSelector } from "@/react/features/customer/customerSlice";
import { useGetAvailableExtensionsQuery } from "@/react/features/support-tools/extensions/extensionsApi";
import React, { useMemo } from "react";
import { DESTINATION_TYPES } from "@/react/features/support-tools/extensions/constants";
import FullWidthDiv from "@/react/features/styled/FullWidthDiv";
import ValidationWrapper from "@/react/components/table/components/ValidationWrapper";
import Select from "@8x8/oxygen-select";
import Input from "@8x8/oxygen-input";

const DestinationColumnSetterInput = ({
  destinationType,
  rule,
  destination,
  onChange,
  errors,
}) => {
  const pbxId = useSelector(pbxIdSelector);
  const { data: extensions, isFetching } =
    useGetAvailableExtensionsQuery(pbxId);
  const options = useMemo(
    () =>
      (extensions || [])
        .filter((extension) =>
          ["EXTENSION", "CALL_QUEUE", "RING_GROUP"].includes(
            extension.serviceType
          )
        )
        .map((extension) => ({
          value: extension.extensionNumber,
          label: extension.extensionNumber,
        })),
    [extensions, destinationType]
  );
  const selectedValue = options.find((option) => option.value === destination);

  if (
    [DESTINATION_TYPES.AUTO_ATTENDANT, DESTINATION_TYPES.EXTENSION].includes(
      destinationType
    )
  ) {
    return (
      <FullWidthDiv>
        <ValidationWrapper errors={errors}>
          <Select
            testId={"destination-select-column-setter"}
            isLoading={isFetching}
            options={options}
            value={selectedValue}
            onChange={(opt) => onChange(opt?.value)}
            hasError={errors?.length > 0}
            isClearable={true}
            isSearchable={true}
          />
        </ValidationWrapper>
      </FullWidthDiv>
    );
  }

  if (destinationType === DESTINATION_TYPES.EXTERNAL_NUMBER) {
    return (
      <ValidationWrapper errors={errors}>
        <Input
          type="text"
          hasError={errors?.length > 0}
          placeholder={`Type value...`}
          value={String(destination || "")}
          onChange={(e) => onChange(e.target.value)}
        />
      </ValidationWrapper>
    );
  }
};

export default DestinationColumnSetterInput;
